import { render, staticRenderFns } from "./antecipacao.vue?vue&type=template&id=9040b8f8&scoped=true"
import script from "./antecipacao.vue?vue&type=script&lang=ts"
export * from "./antecipacao.vue?vue&type=script&lang=ts"
import style0 from "./antecipacao.vue?vue&type=style&index=0&id=9040b8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9040b8f8",
  null
  
)

export default component.exports